import { useState } from 'react';

import IconButton from '@/components/IconButton/IconButton';
import { widgetRegistry, type WidgetId } from '@/features/dashboard/registry';

import WidgetSettingsModal from './WidgetSettingsModal';

const GearIcon = (
  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-4 w-4">
    <path
      fillRule="evenodd"
      d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
      clipRule="evenodd"
    />
  </svg>
);

interface WidgetSettingsButtonProps {
  widgetId: WidgetId;
}

/**
 * Gear that opens a widget's settings from inside its detail modal. Renders
 * nothing for widgets without a settings form. The settings modal is nested,
 * so it opts out of history management.
 */
export default function WidgetSettingsButton({ widgetId }: WidgetSettingsButtonProps) {
  const [open, setOpen] = useState(false);
  if (!widgetRegistry[widgetId].SettingsForm) return null;

  return (
    <>
      <IconButton variant="ghost" size="sm" aria-label="Widget settings" onClick={() => setOpen(true)} icon={GearIcon} />
      <WidgetSettingsModal widgetId={widgetId} open={open} onClose={() => setOpen(false)} manageHistory={false} />
    </>
  );
}
